export const getCommon = state => state.common
